module.exports = __webpack_public_path__ + "img/fr.304ee8f.png";